/**
 * Enum correspondente as situações de parcelas.
 */
export enum SituacaoParcelaEnum {

    PAGO                     = 1,
    A_VENCER                 = 2,
    VENCIDO                  = 3,
    CANCELADO                = 4

}
